import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import {
  getAll,
  getId,
  createItem,
  updateItem,
  deleteById,
} from "./apilogAPI";

const initialState = {
  data: [],
  dataId: null,
  loading: false,
  error: null,
  pageNo: 1,
  pageSize: 10,
  totalRecord: 0,
  selected: null,
  result: null,
};

export const fetchData = createAsyncThunk(
  "apilog/fetchData",
  async (payload) => {
    const response = await getAll(payload);
    return response;
  }
);

export const fetchCrashReport = createAsyncThunk(
  "apilog/fetchCrashReport",
  async (payload) => {
    const response = await getAll(payload);
    return response;
  }
);


export const fetchId = createAsyncThunk("apilog/fetchId", async (id) => {
  const response = await getId(id);
  return response;
});

export const fetchIdNoloading = createAsyncThunk(
  "apilog/fetchIdNoloading",
  async (id) => {
    const response = await getId(id);
    return response;
  }
);

export const addItem = createAsyncThunk("apilog/addItem", async (payload) => {
  const response = await createItem(payload);
  return response;
});

export const editItem = createAsyncThunk(
  "apilog/editItem",
  async (payload) => {
    const response = await updateItem(payload);
    return response;
  }
);
export const removeById = createAsyncThunk(
  "apilog/removeById",
  async (payload) => {
    const response = await deleteById(payload);
    return response;
  }
);

export const apilogSlice = createSlice({
  name: "apilog",
  initialState,
  reducers: {
    resetData: () => initialState,
    setSelected: (state, action) => {
      state.selected = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchData.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchData.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload.data.data;
        state.pageNo = action.payload.data.pageNo;
        state.pageSize = action.payload.data.pageSize;
        state.totalRecord = action.payload.data.totalRecords;
      })
      .addCase(fetchCrashReport.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchCrashReport.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload.data.data;
        state.pageNo = action.payload.data.pageNo;
        state.pageSize = action.payload.data.pageSize;
        state.totalRecord = action.payload.data.totalRecords;
      })
   .addCase(fetchId.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchId.fulfilled, (state, action) => {
        state.loading = false;
        state.dataId = action.payload.data.data;
      })
      .addCase(fetchIdNoloading.pending, (state) => {
        state.loading = false;
      })
      .addCase(fetchIdNoloading.fulfilled, (state, action) => {
        state.loading = false;
        state.dataId = action.payload.data.data;
      })
      .addCase(addItem.pending, (state) => {
        state.loading = true;
      })
      .addCase(addItem.fulfilled, (state, action) => {
        state.loading = false;
        state.result = action.payload;
      })
      .addCase(editItem.pending, (state) => {
        state.loading = true;
      })
      .addCase(editItem.fulfilled, (state, action) => {
        state.loading = false;
        state.result = action.payload;
      })
      .addCase(removeById.pending, (state) => {
        state.loading = true;
      })
      .addCase(removeById.fulfilled, (state, action) => {
        state.loading = false;
        state.result = action.payload;
      });
  },
});

export const { resetData, setSelected } = apilogSlice.actions;

export const selectData = (state) => state.apilog.data;
export const selectCrashReport = (state) => state.apilog.data;
export const selectId = (state) => state.apilog.dataId;
export const selectLoading = (state) => state.apilog.loading;
export const selectError = (state) => state.apilog.error;
export const selectPageNo = (state) => state.apilog.pageNo;
export const selectPageSize = (state) => state.apilog.pageSize;
export const selectTotalRecord = (state) => state.apilog.totalRecord;
export const selectSelected = (state) => state.apilog.selected;
export const selectResult = (state) => state.apilog.result;

export default apilogSlice.reducer;
